import React from "react";

import { IdentityCard } from "./IdentityCard";

export const RemovedIdentityCard = ({ data }) => <IdentityCard data={data} idPrefix="removedIdentity" />;
